<div class="saas-background">
  <div class="container casestudies-body">
    <div class="row">
      <div class="col-md-6 py-5">
        <p class="text-white link-casestudy"><span (click)="nav('/')">Home</span> / <span (click)="nav('/kalpita-case-studies/case-study')">Case Studies</span></p>
        <h1 class="py-3 saas-heading">
          SaaS product to launch a fully functional end-to-end ecommerce store
        </h1>
        <p class="py-3 saas-para">
          Pariwwway is a complete end to end SaaS solution designed to create
          and monetize your business online with a fully custom & functional
          eCommerce store. Developed by the in-house team here at Kalpita, Pariwwway
          is all set to provide complete control over how you operate your
          online business.
        </p>
        <div class="service-industry py-3">
          <div class="industry-box">
            <h6>Industry:<span class="ecommerce">Ecommerce</span></h6>
          </div>
          <div class="service-box">
            <h6>Service:<span>Custom Software Development</span></h6>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <img
          src="../../../../assets/resources/casestudies/mob-saas.webp"
          class="img-fluid mobile-saas cross-mobile" alt="mobileimgs"
        />
        <span class="straigt-mobile"><img class="img-fluid mobile-saas" src="../../../../assets/resources/casestudies/mobile-straight.webp" alt="mobstraight"/></span>
      </div>
    </div>
  </div>
</div>
<!-- The challenge...................................................................... -->
<div class="challenge-background">
  <div class="container">
    <div class="row py-5">
      <h5 class="challenge-head">The challenge</h5>
      <p class="py-3">
        Business owners who sell their products on online marketplaces are
        governed by the policies of the service providers. Moreover, they are
        charged hefty commissions for every sale they make (about 20% of what
        they make goes to the platform).
      </p>
    </div>
  </div>
</div>
<!-- The Solution................................................................................... -->
<div class="container">
  <div class="row">
    <div class="col-md-6 pt-5">
      <h5 class="challenge-head">The Solution</h5>
      <p class="py-4">
        We created an end-to-end ecommerce SaaS product which enables
        any business owner to host their own customized online store to list
        their items, drive traffic, and make sales without having to undercut
        their pricing or pay commissions.
      </p>
      <img src="../../../../assets/resources/casestudies/solutions/solution-saas.webp" alt="solution" width="100%" class="solution-gif">
    </div>

    <div class="col-md-6 solution-background">
      <h5 class="text-white ps-3 py-5 solution-heading">Our Approach and Value add?</h5>
      <div class="solution-data  py-3">
        <h6>Cost efficiency</h6>
        <p class="pt-2">
          There’s no need to buy and maintain expensive hardware, and you only
          pay for the resources your app uses.
        </p>
        <h6>Scalability</h6>
        <p class="pt-2">
          If your requirements increase, you can upgrade your plan in a few
          clicks. Downgrades are also possible.
        </p>
        <h6>Reliability</h6>
        <p class="pt-2">
          A cloud is a network of servers that can be located around the world.
          Even if one server goes down, your app will remain online.
        </p>
        <h6>Security</h6>
        <p class="pt-2">
          Cloud service providers pay close attention to security to ensure your
          data is stored in a safe place.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Technologies used......................................................... -->
<div class="container">
  <div class="row py-5">
    <div class="col-md-8">
      <h5 class="challenge-head py-3">Technologies used</h5>
      <div class="row">
        <div class="col-md-1 py-2"></div>
      <div class="col-md-2 col-6 py-2">
       <img src="../../../../assets/resources/casestudies/icons/java-tech.png" class="img-fluid tech-icon" alt="tecone"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/swift-tech.png" class="img-fluid tech-icon" alt="tectwo"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/angular-tech.png" class="img-fluid tech-icon" alt="tecthree"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/azure-tech.png" class="img-fluid tech-icon" alt="tecfour"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/aspdot-net.png" class="img-fluid tech-icon" alt="tecfive"/>
      </div>
    </div>
    </div>
      <div class="col-md-4">

      </div>
  </div>
</div>
